import { EpStepContent, EpStepTextArea } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';

const WhoWasNotifiedInput = ({ translations }: { translations: string[] }) => {
  return (
    <EpStepContent.Label
      required={false}
      label={t(
        translations,
        'Was a hospital employee notified? Who? (optional)',
      )}
    >
      <EpStepTextArea
        required={false}
        maxLength={200}
        registerId={'whoWasNotified'}
        translations={translations}
      />
    </EpStepContent.Label>
  );
};

export default WhoWasNotifiedInput;
